import { useParams } from "react-router-dom";
import UploadDocumentButton from "../components/content/create-content-button";
import ThemedSpinner from "../components/shared/spinner";
import Typography from "../components/shared/typography";
import TestResultItem from "../components/tests/test-result-item";
import { useSetPageContext } from "../hooks/PageContext";
import useLoadTestById from "../hooks/useLoadTestById";

const DiagnosticTestPage = () => {
  const { testId } = useParams<{ testId: string }>();
  const { test, isLoading, error } = useLoadTestById(testId || "");
  useSetPageContext(test);

  if (isLoading) {
    return (
      <div className="container mx-auto px-4 py-8">
        <ThemedSpinner />
      </div>
    );
  }

  if (!test || error) {
    return (
      <div className="container mx-auto px-4 py-8">
        <Typography variant="h4" className="text-terracotta-500">
          Failed to load diagnostic test
        </Typography>
      </div>
    );
  }

  const results =
    test && Array.isArray(test?.diagnostic_test_result)
      ? test?.diagnostic_test_result
      : [];

  console.log(results);

  return (
    <div className="container mx-auto px-4 py-8">
      <div className="flex justify-end mb-4">
        <UploadDocumentButton />
      </div>
      <Typography variant="h2" className="mb-8 text-terracotta-500">
        {test.test_type || "Diagnostic Test"}
      </Typography>
      {results.length === 0 && (
        <Typography variant="h4" className="text-terracotta-500">
          No results listed.
        </Typography>
      )}
      <div className="grid gap-4">
        {results.map((r) => (
          <TestResultItem key={r.id} result={r} />
        ))}
      </div>
    </div>
  );
};

export default DiagnosticTestPage;
